import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';
// eslint-disable-next-line camelcase
import { invoiceGroups_post_v1 } from '@atlassian/commerce-ccp-gateway-client';

export const createInvoiceGroup = async (transactionAccountId?: string): Promise<void> => {
	if (!transactionAccountId) {
		throw new Error('Missing transactionAccountId');
	}
	getSuccessfulResultOrThrow(
		await invoiceGroups_post_v1({
			fetch,
			headers: {
				'X-transaction-account': transactionAccountId,
			},
			body: {
				name: 'USD',
				currency: 'USD',
			},
		}),
	);
};
